<template>
    <div class="sign-up-header" :class="sectionClass">
        <h1 class="sign-up-header__title">
            <span v-html="title"></span>
        </h1>
    </div>
</template>

<script>
    export default {
        name: 'SignUpHeader',
        props: {
            currentApp: String,
            title: String
        },
        computed: {
            sectionClass () {
                return 'sign-up-header--' + this.currentApp;
            }
        }
    }
</script>

<style lang="scss">
    .sign-up-header {
        padding: 33px 20px;
        min-height: 150px;
        left: 0;
        top: 50px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;


        &, &--community {
            padding: 0;
            min-height: 100%;

            & > .sign-up-header__title {
              padding: 20px !important;
              width: 100%;
              background: #db2b22 url('/images/_/signup-banner-back.png') no-repeat top right / contain;
              max-width: 100% !important;

              @media (max-width: 1079px) {
                font-size: 18px;
                line-height: 24px;
              }

              @media (max-width: 768px)  {
                background-size: cover;
                padding: 30px !important;
              }
            }
        }
        &--partner_program {
            background: radial-gradient(107.97% 103.68% at 50% 100%, #508dff 15.63%, #004fe3 100%);
        }
        &--print, &--workbench {
            background: linear-gradient(180deg, #33AADD 0%, #0088C2 100%)
        }
        &--shop {
            background: linear-gradient(180deg, #2254B3 0%, #003393 100%);
        }

        &__title {
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 33px;
            text-align: center;
            color: #FFFFFF;
            max-width: 496px;
        }
    }
</style>
